import type { AnyObject } from "../types/utility";

export const getKeys = Object.keys as <T extends AnyObject>(obj: T) => Array<keyof T>;

export const objectFromKeys = <T extends Array<string>>(keys: T): AnyObject =>
	keys.reduce<AnyObject>((ac, a) => ({ ...ac, [a]: "" }), {});

export const omit = <T, E extends keyof T>(obj: T, ...exclude: Array<E>): Omit<T, E> => {
	const res = { ...obj };
	exclude.forEach((key) => {
		delete res[key];
	});
	return res;
};

export const isObject = (x: unknown): x is AnyObject =>
	typeof x === "object" && !Array.isArray(x) && x !== null;

export const deepEqual = (object1: AnyObject, object2: AnyObject) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (const key of keys1) {
		const val1 = object1[key];
		const val2 = object2[key];
		const areObjects = isObject(val1) && isObject(val2);
		if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
			return false;
		}
	}

	return true;
};
